import axios from '../api';

/**
 * Service for AI model configuration management
 */

/**
 * Get AI model configuration
 * @returns {Promise<Object>} AI model configuration
 */
export const getAIModelConfig = async () => {
  try {
    const response = await axios.get('/configs/ai-model');
    return response.data;
  } catch (error) {
    console.error('Error fetching AI model configuration:', error);
    throw error;
  }
};

/**
 * Update AI model configuration
 * @param {Object} configData - AI model configuration data
 * @returns {Promise<Object>} Updated configuration
 */
export const updateAIModelConfig = async (configData) => {
  try {
    const response = await axios.put('/configs/ai-model', configData);
    return response.data;
  } catch (error) {
    console.error('Error updating AI model configuration:', error);
    throw error;
  }
};

/**
 * Test AI configuration
 * @returns {Promise<Object>} Test results
 */
export const testAIConfiguration = async () => {
  try {
    const response = await axios.post('/patients/test-patient/ai-problem-list/test');
    return response.data;
  } catch (error) {
    console.error('Error testing AI configuration:', error);
    throw error;
  }
};
